import { Component, ViewChild, ViewContainerRef, ComponentRef, AfterViewInit } from '@angular/core';
import { MerakiNetworkFormComponent } from '@app/features/merakis/components/network-form/network-form.component';
import { MerakiSwitchFormComponent } from '@app/features/merakis/components/switch-form/switch-form.component';
import { MerakiNetwork } from '@app/shared/models/meraki/meraki-network.model';

@Component({
    selector: 'app-meraki-go-provisioning',
    templateUrl: './meraki-go-provisioning.component.html',
    styleUrls: ['./meraki-go-provisioning.component.scss'],
    standalone: false
})
export class MerakiGoProvisioningComponent implements AfterViewInit{
    @ViewChild(MerakiNetworkFormComponent) networkFormComponent: MerakiNetworkFormComponent;
    @ViewChild('addSwitchHere', { read: ViewContainerRef }) target: ViewContainerRef;
    private switchFormComponentRefs: ComponentRef<MerakiSwitchFormComponent>[] = [];

    ngAfterViewInit() {
        this.addSwitchToForm();
    }

    async submit() {
        if (this.networkFormComponent.networkForm.errors == null) {
            const network: MerakiNetwork = await this.networkFormComponent.createNetwork();
            await this.networkFormComponent.bindNetwork(network.id);
            await this.switchFormComponentRefs.forEach((switchFormComponentRef: ComponentRef<MerakiSwitchFormComponent>) => {
                if (switchFormComponentRef.instance.switchForm.errors == null) {
                    switchFormComponentRef.instance.claimSwitch(network.id);
                }
            });
        }
    }

    addSwitchToForm() {
        let switchFormComponentRef = this.target.createComponent(MerakiSwitchFormComponent);
        this.switchFormComponentRefs.push(switchFormComponentRef);
    }

    removeSwitchFromForm() {
        if (this.switchFormComponentRefs.length > 0) {
            this.target.remove(this.switchFormComponentRefs.length);
            this.switchFormComponentRefs.pop();
        }
    }

    clear() {
        this.networkFormComponent.clear();
        this.networkFormComponent.networkForm.get('type').setValue("switch");
        this.switchFormComponentRefs.forEach((switchFormComponentRef: ComponentRef<MerakiSwitchFormComponent>) => {
            switchFormComponentRef.instance.switchForm.get('serial').setValue(null);
            switchFormComponentRef.instance.switchForm.get('serial').clearValidators()
            switchFormComponentRef.instance.switchForm.get('serial').updateValueAndValidity();
        });
    }
}